import { render, staticRenderFns } from "./TopDisconnects.vue?vue&type=template&id=31b3a4c9&"
import script from "./TopDisconnects.vue?vue&type=script&lang=ts&"
export * from "./TopDisconnects.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports